<script setup lang="ts">
import type { FilterChipProps } from '.';
import type { ButtonProps } from '@/components/ui/button/';

import { Button } from '@/components/ui/button';

defineProps<FilterChipProps>();

const isActive = defineModel<boolean>('modelValue', {
	required: false,
	default: false
});

const variant = computed<ButtonProps['variant']>(() =>
	isActive.value ? 'primary' : 'tertiary'
);
</script>

<template>
	<Button
		class="flex w-min items-center justify-center gap-2 px-2 py-[0.37rem]"
		:variant="variant"
		@click="isActive = !isActive"
	>
		<IconMaterialSymbolsLightClose v-if="isActive" class="size-5" />
		<IconMaterialSymbolsLightAdd v-else class="size-5" />

		<span class="text-sm font-normal">
			{{ label }}
		</span>
	</Button>
</template>
